/**
 * ERP & Treuhandbüro Data Portability / Connector Module (`web/src/components/LanguageChooser.tsx`).
 *
 * @statutory OR Art. 957a Abs. 2 Ziff. 1–5 (Vollständige & nachprüfbare Buchführung) · GeBüV Art. 6–10 (Datenübernahme & Prüfspur) · MWSTG Art. 70 · Schweizer Kontenrahmen KMU
 */
import { useLang } from '../lib/i18n';

export function LanguageChooser({ className = '' }: { className?: string }) {
  const { lang, setLang, t } = useLang();
  return (
    <div className={`segmented ${className}`.trim()} role="group" aria-label={t('lang.label')}>
      <button
        type="button"
        aria-pressed={lang === 'de'}
        onClick={() => setLang('de')}
        title="Deutsch (DE)"
        aria-label="Deutsch"
      >
        DE
      </button>
      <button
        type="button"
        aria-pressed={lang === 'en'}
        onClick={() => setLang('en')}
        title="English (EN)"
        aria-label="English"
      >
        EN
      </button>
    </div>
  );
}
